import { constantsTypes } from '../reduxConstants'

export const setGrandTotalamount = (value) => {
  return {
    type: constantsTypes.GRAND_TOTAL,
    value: value,
  }
}